import { CheckIcon } from 'lucide-react'

const DONE_STEPS = ['Account created', 'Email confirmed']

export const AddCardSteps = () => (
  <ul className="flex flex-col gap-2.5 border-y py-4 text-sm">
    {DONE_STEPS.map((step) => (
      <li key={step} className="flex items-center gap-2.5">
        <CheckIcon aria-hidden className="size-4 text-brand-deep" />
        {step}
      </li>
    ))}
    <li className="flex items-center gap-2.5 font-semibold">
      <span
        aria-hidden
        className="size-4 rounded-full border-2 border-foreground"
      />
      Add a card to start the trial
    </li>
  </ul>
)
